module.exports = __webpack_public_path__ + "media/images/flags/32/Cayman-Islands-7b8702f7fe137a9cd875a881a8836e6b.png";